import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getAllRequests } from '../../api/request';
import { isPending, sortRequests } from './workflow';

export default function MyRequestsInbox() {
  const userId = useSelector((state: any) => state.auth.user?.id);
  const [requests, setRequests] = useState<any[]>([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const response = await getAllRequests(undefined, 'mine');
        if (active) {
          setRequests(sortRequests((response.data || []).filter((request: any) => request.Taches?.some((task: any) => task.id_userProfil === userId && isPending(task)))));
          setError(false);
        }
      } catch { if (active) setError(true); }
      finally { if (active) setLoading(false); }
    };
    void load();
    // Refresh on return to the dashboard, without keeping idle sessions alive.
    const onFocus = () => { void load(); };
    window.addEventListener('focus', onFocus);
    return () => { active = false; window.removeEventListener('focus', onFocus); };
  }, [userId]);
  return <section className="card mb-3"><div className="card-body">
    <div className="d-flex justify-content-between align-items-center"><h4>Mes demandes à traiter</h4><Link to="/requests">Voir ma file de traitement →</Link></div>
    {loading ? <p>Chargement…</p> : error ? <p className="text-danger">Le suivi des demandes est temporairement indisponible.</p> : <>
      <p>{requests.length} demande(s) en attente. Priorité, puis ordre d’arrivée.</p>
      {requests.slice(0, 3).map(request => <Link key={request.id} to={`/request-details/${request.id}`} className="d-flex justify-content-between gap-2 border-top py-2"><span>{request.number_request} — {request.StudentProfil?.firstname} {request.StudentProfil?.lastname}</span><strong>{request.priority}</strong></Link>)}
      {!requests.length && <span className="text-muted">Vous n’avez aucune demande à traiter.</span>}
    </>}
  </div></section>;
}
